module.exports = __webpack_public_path__ + "img/D8.d232bdeb.png";